import React , { useState , useEffect } from 'react'
import useHttp from "../../../../hooks/use-http";
import { Typography } from '@mui/material'
import { Box } from '@mui/system'

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import { CategoryCard } from 'components'
import { GridSearchIcon, HackIcon, LockIcon, ShieldKeyIcon, WindowsIcon } from 'Sui_Icons'

import style from './IntractiveLearning.module.scss'

export const IntractiveLearning = () => {
    const { isLoading, sendRequest: fetchTopCategoriesOfCourse } = useHttp();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = (course)=>{
            setCategories(course.data.categories)
            console.log(course.data.categories);
        }

        fetchTopCategoriesOfCourse({url : `home/top_categories_interactive`} , fetchCategories)
    }, [fetchTopCategoriesOfCourse]);

    return (
        <Box sx={{ display: { lg: 'flex' }, my: 4, alignItems: 'flex-start', flexDirection: { xs: 'column', lg: 'row' } }}>

            <Box sx={{ flexBasis: { lg: '25%' }, mr: 10, mt: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', my: 1.5 }}>
                    <Box sx={{ width: '30px', height: '30px', background: 'rgba(5, 198, 197, 0.26)', borderRadius: '50%', marginRight: '-15px' }}></Box>
                    <GridSearchIcon />
                    <Typography sx={{ marginLeft: 1 }} fontWeight={'700'} fontSize={{ xs: 16, lg: 20 }}>آموزش تعاملی</Typography>
                </Box>
                <Typography sx={{ display: { xs: 'none', lg: 'block' } }} fontSize={{ xs: 10, lg: 13 }} color='GrayText' >همین الان یادگیری رو شروع کن ،مسیر موفقیت رو طی کن</Typography>
            </Box>

            <Box width={{ lg: '75%' }} sx={{ display: { xs: 'block' }, maxWidth: '100vw', mt: { xs: 2, lg: 0 } }}>
                <Swiper
                    spaceBetween={10}
                    breakpoints={
                        {
                            320: {
                                slidesPerView: 2
                            },
                            640: {
                                slidesPerView: 4
                            }

                        }
                    }
                    loop={true}
                    pagination={{
                        clickable: true,
                        bulletClass: style.bullet,
                        bulletActiveClass: style.activeBullet

                    }}
                    modules={[Pagination]}
                    className={style.paginationSwiper}
                >
                    {categories.map(category =>
                        <SwiperSlide>
                            <CategoryCard 
                                title= {category.name}
                                Icon= {LockIcon}
                                link= {'#'}
                                activeCoursesCount= {category.activeCourse}  
                            />
                        </SwiperSlide>)}
                </Swiper>
            </Box>
        </Box>
    )
}
